/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React, { useState } from "react";
import "./style.css";

export const CmpSendbutton = ({ state, className, onClick = () => {} }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isPressed, setIsPressed] = useState(false);

  const handleMouseEnter = () => {
    if (state !== 'disabled') {
      setIsHovered(true);
    }
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    setIsPressed(false);
  };

  const handleMouseDown = () => {
    if (state !== 'disabled') {
      setIsPressed(true);
    }
  };

  const handleMouseUp = () => {
    setIsPressed(false);
  };

  const handleClick = (e) => {
    if (state !== 'disabled') {
      onClick(e);
    }
  };

  // Determine the effective state based on interactions
  let effectiveState = state;
  if (state !== 'disabled') {
    if (isPressed) {
      effectiveState = 'pressed';
    } else if (isHovered) {
      effectiveState = 'hover';
    }
  }

  // Determine fill and stroke colors based on effective state
  let bgColor = '#1f6c4f'; // Cedar primary default
  let fillColor = 'white';
  let strokeColor = 'none';
  
  if (state === 'disabled') {
    bgColor = '#e8f2ed';
    fillColor = '#c1c9c5';
    strokeColor = 'rgba(31, 108, 79, 0.2)';
  } else if (effectiveState === 'hover' || isHovered) {
    bgColor = '#42A5A5'; // Sky blue on hover
    fillColor = 'white';
  } else if (effectiveState === 'pressed' || isPressed) {
    bgColor = '#3e9694'; // Darker blue on press
    fillColor = 'white';
  }
  
  return (
    <svg
      className={`cmp-sendbutton ${effectiveState} ${className}`}
      width="30"
      height="30"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      style={{ 
        cursor: state === 'disabled' ? 'not-allowed' : 'pointer',
        transition: 'all 0.2s ease'
      }}
    >
      {/* Background rounded rectangle - viewBox 0 0 36 36, rect fills it; SVG displayed at 30x30 */}
      <rect x="0" y="0" width="36" height="36" rx="8" ry="8" fill={bgColor} stroke={strokeColor} strokeWidth={strokeColor !== 'none' ? '1' : '0'} style={{ transition: 'fill 0.2s ease' }} />
      {/* Paper airplane icon - centered in 36x36, scaled for clear visibility */}
      <g transform="translate(18, 18) scale(1.55) translate(-18, -18)">
        <path
          d="M11 28V12L30 20L11 28ZM13 25L24.85 20L13 15V18.5L19 20L13 21.5V25Z"
          fill={fillColor}
          transform="translate(-1 -1)"
        />
      </g>
    </svg>
  );
};

CmpSendbutton.propTypes = {
  state: PropTypes.oneOf(["default", "hover", "pressed", "disabled", "inactive"]),
  onClick: PropTypes.func,
};
